import PropTypes from "prop-types"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { TextField, InputAdornment, Button } from "@mui/material"
import { MailOutlined, CheckCircleOutline } from "@mui/icons-material"
import Error from "../../components/login/form-error"
import "./style.scss"

export default function ForgotPassword({ emailSent, resetPassword, errorMessage, clearError, reset, email }) {
  const navigate = useNavigate()
  const [selectedEmail, setEmail] = useState(email)

  const handleChange = (e) => {
    if (e.target.name === "email") {
      setEmail(e.target.value)
    }
  }

  const goBack = () => {
    reset()
    navigate("/")
  }

  const handleResetClick = event => {
    event.preventDefault()
    if (selectedEmail) {
      resetPassword(selectedEmail)
    }
  }

  const display = emailSent ? <>
    <div className="title">Password reset sent!</div>
    <div className="text">
      We&apos;ve just emailed you instructions on how to reset your password.
      Please check your spam folder if you haven&apos;t received it in a few minutes.
    </div>
    <CheckCircleOutline className="check-password-sent" />
  </> : <>
    <div className="title">Forgot your password?</div>
    <div className="text">We will email you instructions on how to reset it</div>
    {errorMessage && <Error errorMessage={errorMessage} clearError={() => clearError()} />}
    <form className="form" onSubmit={handleResetClick}>
      <TextField
        name="email"
        placeholder="Email"
        onChange={handleChange}
        value={selectedEmail}
        variant="outlined"
        slotProps={{
          input: {
            startAdornment: <InputAdornment style={{ whiteSpace: "nowrap" }} position="start"><MailOutlined className="textinput-icon" /></InputAdornment>,
          },
        }}
      />
      <Button type="submit" className="reset-button" variant="contained" color="primary" disabled={!selectedEmail}>Reset password</Button>
    </form>
  </>

  return <div className="forgotPassword">
    {display}
    <div className="navigate" onClick={goBack}>Back to login</div>
  </div>
}

ForgotPassword.propTypes = {
  emailSent: PropTypes.bool,
  resetPassword: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  reset: PropTypes.func.isRequired,
  email: PropTypes.string,
}
